import * as React from 'react';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        margin: '0 15px',
        display: 'flex',
        alignItems: 'center',
    },
    checkbox: {
        transform: 'scale(1.3)',
        flex: '0 0 auto',
        marginRight: 10,
        marginTop: 0,
    },
    text: {
        fontSize: 12,
    },
};

interface IProps {
    checked: boolean;
    text: string;
    onChange(event: React.ChangeEvent<any>): void;
    wrapperStyles?: React.CSSProperties;
}

export function NewsletterSubscription(props: IProps) {
    return (
        <div style={{ ...styles.wrapper, ...props.wrapperStyles }}>
            <input
                type="checkbox"
                defaultChecked={props.checked}
                onChange={props.onChange}
                style={styles.checkbox}
            />
            <span style={styles.text} dangerouslySetInnerHTML={{ __html: props.text }} />
        </div>
    );
}
